import { stats } from "@/mocks/content";
import SectionHeading from "@/components/feature/SectionHeading";

const principles = [
  { icon: "ri-scales-3-line", t: "证据先行", d: "截图要可核验，行程要对得上，多信源交叉再下笔。" },
  { icon: "ri-eye-off-line", t: "保护无辜", d: "涉及隐私与名誉的内容一律拦截，不为流量伤人。" },
  { icon: "ri-time-zone-line", t: "让子弹飞", d: "不抢首发当枪使，当事人回应前不轻易定性。" },
  { icon: "ri-leaf-line", t: "理性回落", d: "瓜要吃，日子更要过，情绪上头时先喝口水。" },
];

const columnsDesc = [
  "瓜友求锤得锤 —— 证据导向的求证现场",
  "预言家挖坟现场 —— 公开信息的时间线复盘",
  "粉丝脱粉回踩 —— 真情实感的回头看",
  "站姐爆料专区 —— 镜头内外的现场侧记",
  "业内匿名爆料 —— 片场综艺的幕后规则",
];

export default function About() {
  return (
    <section id="about" className="w-full bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="overflow-hidden rounded-2xl bg-foreground-950">
          <div className="grid lg:grid-cols-2">
            {/* narrative */}
            <div className="flex flex-col justify-center p-7 md:p-12">
              <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.2em] text-accent-400">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-400" aria-hidden="true" /> 关于每日大瓜
              </p>
              <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-background-50 md:text-3xl">
                想听点不一样的，<br className="hidden md:block" />来这里就对了
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-background-100">
                每日大瓜是一个专注娱乐吃瓜情报与行业舆情观察的内容站。我们相信吃瓜可以很认真：与其在
                碎片化的截图与情绪化转发里来回折腾，不如把旧账新料摊开，用可核验的方式逐条求证。
              </p>
              <p className="mt-4 text-sm leading-relaxed text-background-100">
                从求锤得锤的求证区，到挖坟现场的时间线复盘，再到站姐与业内信源的第一手侧记，我们坚持
                多路信源交叉验证。作为编辑部，我们的立场始终是——<span className="text-accent-300">吃瓜但不伤人，八卦且有分寸</span>。
              </p>
              <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-4">
                {stats.map((s) => (
                  <div key={s.label} className="rounded-lg bg-white/5 px-3 py-4 text-center ring-1 ring-white/10">
                    <p className="font-heading text-xl font-black text-primary-400 md:text-2xl">{s.num}</p>
                    <p className="mt-1 text-[11px] text-background-200">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* principles + columns */}
            <div className="flex flex-col justify-center gap-6 border-t border-white/10 p-7 md:p-12 lg:border-l lg:border-t-0">
              <div>
                <h3 className="flex items-center gap-2 text-sm font-bold tracking-wider text-background-50">
                  <i className="ri-shield-star-line text-accent-400" aria-hidden="true" /> 我们的内容原则
                </h3>
                <div className="mt-4 grid gap-3 sm:grid-cols-2">
                  {principles.map((p) => (
                    <div key={p.t} className="rounded-lg bg-white/5 p-3.5 ring-1 ring-white/10">
                      <p className="flex items-center gap-2 text-sm font-bold text-background-50">
                        <i className={`${p.icon} text-accent-400`} aria-hidden="true" /> {p.t}
                      </p>
                      <p className="mt-1.5 text-xs leading-relaxed text-background-200">{p.d}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="flex items-center gap-2 text-sm font-bold tracking-wider text-background-50">
                  <i className="ri-store-2-line text-primary-400" aria-hidden="true" /> 五大吃瓜栏目
                </h3>
                <ul className="mt-4 space-y-2">
                  {columnsDesc.map((c, i) => (
                    <li key={c} className="flex items-center gap-3 text-sm text-background-100">
                      <span className="font-heading text-xs font-black text-primary-400">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {c}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* bottom band heading */}
        <div className="mt-12 flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
          <SectionHeading
            eyebrow="口碑与口碑之外"
            title="被瓜友记住的，从来不只是瓜"
            desc="我们把每位读者的留言当回事。下面是几则来自瓜友的真实评价片段，感谢你们一起理性吃瓜。"
          />
          <div className="flex shrink-0 gap-2">
            <span className="flex items-center gap-1 rounded-full bg-primary-100 px-3 py-1.5 text-xs font-medium text-primary-700">
              <i className="ri-star-fill" aria-hidden="true" /> 瓜友口碑 4.9 / 5
            </span>
            <span className="flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1.5 text-xs font-medium text-accent-700">
              <i className="ri-heart-3-fill" aria-hidden="true" /> 编辑部认真值班
            </span>
          </div>
        </div>

        {/* quotes */}
        <div className="mt-6 grid gap-5 md:grid-cols-3">
          {[
            {
              quote: "求锤区是真的会把四路机位逐帧对齐，这种较真劲儿我服气。",
              who: "来自某视频平台的重度吃瓜用户",
            },
            {
              quote: "回踩长文栏目让人看到流量背后也有人味，不是一味的恨。",
              who: "一位看了三年大瓜的老瓜友",
            },
            {
              quote: "站姐手记比营销号的通稿有温度多了，编辑部审稿很谨慎。",
              who: "匿名投稿的站姐之一",
            },
          ].map((q, i) => (
            <figure
              key={i}
              className="flex flex-col rounded-2xl border border-background-200 bg-background-100 p-6"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-300" aria-hidden="true" />
              <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {q.quote}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-2 text-xs text-foreground-500">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-user-heart-line" aria-hidden="true" />
                </span>
                {q.who}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}